'use client';

import { motion, useMotionValue, useTransform } from 'motion/react';

import * as Checkbox from '@radix-ui/react-checkbox';

interface Props {
  isChecked: boolean;
  setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
}
const MotionCheckbox: React.FC<Props> = ({ isChecked, setIsChecked }) => {
  const pathLength = useMotionValue(isChecked ? 1 : 0);
  const strokeLinecap = useTransform(() =>
    pathLength.get() === 0 ? 'none' : 'round'
  );

  const variants = {
    visible: { background: `oklch(from var(--foreground) l c h / 100%)` },
    hidden: { background: `oklch(from var(--background) l c h / 10%)` },
  };

  return (
    <div className="container">
      <Checkbox.Root className="root" asChild>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial="hidden"
          animate={isChecked ? 'visible' : 'hidden'}
          variants={variants}
          transition={{ duration: 0.1 }}
          onTap={() => setIsChecked(!isChecked)}
          data-primary-action>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--background)"
            strokeWidth="3">
            <motion.path
              d="M4 12L10 18L20 6"
              animate={{ pathLength: isChecked ? 1 : 0 }}
              transition={{
                type: 'spring',
                bounce: 0,
                duration: isChecked ? 0.4 : 0.1,
              }}
              style={{
                pathLength,
                strokeLinecap,
              }}
            />
          </svg>
        </motion.button>
      </Checkbox.Root>
      <StyleSheet />
    </div>
  );
};
export default MotionCheckbox;

/**
 * ==============   Styles   ================
 */
function StyleSheet() {
  return (
    <style>{`
            .container {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .root {
                width: 24px;
                height: 24px;
                border-radius: 6px;
                background-color: var(--layer);
                border: 1px solid oklch(from var(--foreground) l c h / 20%);
                cursor: pointer;
                padding: 2px;
            }

            .root:focus-visible {
                outline: none;
                // border-color: #4ff0b7;
            }
        `}</style>
  );
}
